// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__AG2q4","summary":"CartItem_summary__sldn5","price":"CartItem_price__UqLKe","amount":"CartItem_amount__Psxb1","actions":"CartItem_actions__YZrhT"};